import React from 'react'
import styles from './FeatureContainer.module.css'
import { PROJECT_BRANCH_COLORS, ProjectBranch } from '../projectBranch'

type FeatureContainerProps = {
    children: React.ReactNode
    /** アクセント色(--feature-accent)を直接指定。省略時は既定 #b08d4a */
    accentColor?: string
    /**
     * サイト(hotelslabo / foodslabo)の判定。これに対応するテーマカラーを
     * --feature-project-branch-color にセットする（求人カードのアイコン・ボタン・バッジ）。
     * 省略時は求人カード側の var フォールバック #FF9100。
     */
    projectBranch?: ProjectBranch
}

/**
 * 特設LP共通の外枠。max-width 430px の中央カード＋フォント/文字色のベース。
 * アクセント色は各コンポーネントが var(--feature-accent, #b08d4a) を、
 * サイトのテーマカラーは求人カードが var(--feature-project-branch-color, #FF9100) を
 * 参照するので、accentColor / projectBranch でここから差し替えられる。
 */
export default function FeatureContainer({
    children,
    accentColor,
    projectBranch,
}: FeatureContainerProps) {
    const branchColor = projectBranch
        ? PROJECT_BRANCH_COLORS[projectBranch]
        : undefined
    const cssVars: React.CSSProperties = {
        ...(accentColor && { '--feature-accent': accentColor }),
        ...(branchColor && {
            '--feature-project-branch-color': branchColor,
        }),
    } as React.CSSProperties

    return (
        <div className={styles.page}>
            <div
                className={styles.container}
                style={accentColor || branchColor ? cssVars : undefined}
            >
                {children}
            </div>
        </div>
    )
}
